import { Config } from '@/config';
import { uniq } from '@/util/array-util';

export function getBrowserLocales() {
  let locales = [];

  if (typeof window !== 'undefined') {
    const { navigator } = window;

    if (navigator.languages) {
      locales = locales.concat(navigator.languages);
    }
    if (navigator.language) {
      locales.push(navigator.language);
    }
    if (navigator.userLanguage) {
      locales.push(navigator.userLanguage);
    }
    if (navigator.browserLanguage) {
      locales.push(navigator.browserLanguage);
    }
    if (navigator.systemLanguage) {
      locales.push(navigator.systemLanguage);
    }
  }

  locales.push(Config.i18n.defaultLocale);

  return normalizeLocales(uniq(locales));
}

function normalizeLocales(arr) {
  return arr.map((x) => {
    if (!x || x.indexOf('-') === -1 || x.toLowerCase() !== x) {
      return x;
    }

    const tokens = x.split('-');
    return `${tokens[0]}-${tokens[1].toUpperCase()}`;
  });
}
